import script from "./CheckListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckListItem.vue?vue&type=script&setup=true&lang=js"

import "./CheckListItem.vue?vue&type=style&index=0&id=6ea0d5ac&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea0d5ac"]])

export default __exports__